var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 235,
    viewBox: "0 0 239 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.002 94.5007C152.453 101.951 152.448 114.047 145.002 121.493L123.576 142.92C119.257 147.239 112.251 147.239 107.933 142.92L88.7572 123.744L118.005 94.4964C125.456 87.0459 137.552 87.0502 144.998 94.4964L145.002 94.5007Z",
    fill: "url(#paint0_linear_8_101)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.002 94.5007C152.453 101.951 152.448 114.047 145.002 121.493L123.576 142.92C119.257 147.239 112.251 147.239 107.933 142.92L88.7572 123.744L118.005 94.4964C125.456 87.0459 137.552 87.0502 144.998 94.4964L145.002 94.5007Z",
    fill: "url(#paint1_linear_8_101)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5009 94.502C93.9513 87.0515 106.047 87.0558 113.494 94.502L142.742 123.75L123.566 142.926C119.247 147.244 112.242 147.244 107.923 142.926L86.4965 121.499C79.046 114.049 79.0504 101.952 86.4965 94.5063L86.5009 94.502Z",
    fill: "url(#paint2_linear_8_101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.208 95.2091C94.2678 88.1493 105.731 88.1533 112.786 95.2091L141.327 123.75L122.859 142.219C118.931 146.147 112.558 146.147 108.63 142.219L87.2036 120.792C80.1438 113.732 80.1478 102.269 87.2036 95.2134L87.208 95.2091Z",
    stroke: "url(#paint3_linear_8_101)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_101",
    x: 0.757202,
    y: 0.910156,
    width: 237.831,
    height: 233.249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44,
    result: "effect1_foregroundBlur_8_101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8_101",
    x: 62.9103,
    y: 70.9158,
    width: 97.8313,
    height: 93.2488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8_101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8_101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_101",
    x1: 147.582,
    y1: 94.0417,
    x2: 101.278,
    y2: 136.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF027A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_101",
    x1: 147.582,
    y1: 94.0417,
    x2: 101.278,
    y2: 136.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF027A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_101",
    x1: 114.855,
    y1: 146.81,
    x2: 127.469,
    y2: 90.9452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_101",
    x1: 78.2676,
    y1: 109.459,
    x2: 133.918,
    y2: 98.6737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ad9cb44ce8cf152045820388eca057de.svg";
export { ForwardRef as ReactComponent };